module.exports = __webpack_public_path__ + "img/3.090938d4.png";